import GroupAssignment from "@/workflow/components/configurations/assign-group";
import { useUIStore } from "../store/uiStore";
import { useWorkflowStore } from "../store/workflowStore";
import FormDesign from "@/workflow/components/configurations/form/FormDesign";
import { IfDetails } from "@/workflow/components/configurations/if";
import { SwitchDetails } from "@/workflow/components/configurations/switch";
import { CalculatedFieldDetails } from "@/workflow/components/configurations/calculated-field";
import { DataCenterDetails } from "@/workflow/components/configurations/data-center";
import { ExpedienteDetails } from "@/workflow/components/configurations/expediente";
import { DocumentGeneratorDetails } from "@/workflow/components/configurations/doc-generator";
import { DigitalSignatureDetails } from "@/workflow/components/configurations/digital-signature";
import { PaymentNodeDetails } from "@/workflow/components/configurations/payment-node";
import { MultiThreadDetails } from "@/workflow/components/configurations/multi-thread";
import { InteroperabilityDetailsForm } from "@/workflow/components/configurations/interoperability";
import { NodeTypes } from "../types/workflow";
import { TimerDetails } from "@/workflow/components/configurations/timer";
import { CorrectionDetails } from "@/workflow/components/configurations/correction";
import NotificationDetails from "@/workflow/components/configurations/notification";
import N8NDetails from "@/workflow/components/configurations/n8n";
import { WaitDetails } from "@/workflow/components/configurations/wait";
import { ResolutionDetails } from "@/workflow/components/configurations/resolution";
import { MergeDetails } from "@/workflow/components/configurations/merge";

const NodeDetailsModal = () => {
  const { selectedNodeId, timerDetailsOpen } = useUIStore();
  const { getNodeById } = useWorkflowStore();
  if (!selectedNodeId) return;

  const node = getNodeById(selectedNodeId);

  if (!node) return;

  if (node?.data?.type === NodeTypes.IF) {
    return <IfDetails />;
  }
  if (node?.data?.type === NodeTypes.FORM && !timerDetailsOpen) {
    return <FormDesign />;
  }

  if (
    (node?.data?.type === NodeTypes.FORM ||
      node?.data?.type === NodeTypes.CORRECTION) &&
    timerDetailsOpen
  ) {
    return <TimerDetails />;
  }

  if (node?.data?.type === NodeTypes.SWITCH) {
    return <SwitchDetails />;
  }
  if (node?.data?.type === NodeTypes.CALCULATED) {
    return <CalculatedFieldDetails />;
  }
  if (node?.data?.type === NodeTypes.ASSIGN_GROUP) {
    return <GroupAssignment />;
  }
  if (node?.data?.type === NodeTypes.CORRECTION) {
    return <CorrectionDetails />;
  }
  if (node?.data?.type === NodeTypes.DATA_CENTER) {
    return <DataCenterDetails />;
  }
  if (node?.data?.type === NodeTypes.EXPEDIENTE) {
    return <ExpedienteDetails />;
  }
  if (node?.data?.type === NodeTypes.DOC_GENERATOR) {
    return <DocumentGeneratorDetails />;
  }
  if (node?.data?.type === NodeTypes.PAYMENT) {
    return <PaymentNodeDetails />;
  }
  if (node?.data?.type === NodeTypes.SIGN_DOCUMENT) {
    return <DigitalSignatureDetails />;
  }
  if (node?.data?.type === NodeTypes.MULTITHREAD) {
    return <MultiThreadDetails />;
  }
  if (node?.data?.type === NodeTypes.WAIT) {
    return <WaitDetails />;
  }
  if (node?.data?.type === NodeTypes.NOTIFICATION) {
    return <NotificationDetails />;
  }
  if (node?.data?.type === NodeTypes.INTEROPERABILITY) {
    return <InteroperabilityDetailsForm />;
  }
  if (node?.data?.type === NodeTypes.N8N) {
    return <N8NDetails />;
  }
  if (node?.data?.type === NodeTypes.RESOLUTION) {
    return <ResolutionDetails />;
  }
  if (node?.data?.type === NodeTypes.MERGE) {
    return <MergeDetails />;
  }
  return null;
};

export default NodeDetailsModal;
